import React from "react";
import Footer from "../Component/Footer/Footer";
import Header from "../Component/Header/Header";
import Login from "Pages/Login/Login";

import Latestupdate from "../Component/Latestupdate/Latestupdate";

export default function Logintheme() {
  return (
    <>
      {/* <Header /> */}
        <Login />
        {/* <Latestupdate /> */}
      {/* <Footer /> */}
    </>
  );
}
